export const getColor = (tag) => {
  switch(tag) {
    case "CSS":
        return "success";
    case "Databases":
        return "cyan";
    case "Full-Stack Development":
        return "red";
    case "Firebase":
        return "volcano";
    case "HTML":
        return "magenta";
    case "JavaScript":
        return "orange";
    case "React.js":
        return "green";
    case "Web Development":
        return "gold";
    case "TypeScript":
        return "blue";
    case "Next.js":
        return "geekblue";
    case "Software Design Patterns":
        return "purple";
    case "Software Development":
        return "lime";
    case "Software Documentation":
        return "brown";
    case "Tailwind":
        return "cyan";
    case "User Interface Design":
        return "antiquewhite";
    case "Web Application Design":
        return "navajowhite";
    case "Cascading Style Sheets (CSS)":
        return "success";
    case "Analytical Skills":
        return "lime";
    case "Fabric.js":
        return "geekblue";
    case "Front-End Development":
        return "orange";
    case "Git":
        return "cyan";
    case "GitHub":
        return "volcano";
    case "Material-UI":
        return "purple";
    case "Problem Solving":
        return "gold";
    case "Responsive Web Design":
        return "cyan";
    case "Software Architecture":
        return "red";
    case "Software Testing":
        return "#FFDC97";
    case "User Experience (UX)":
        return "antiquewhite";
    case "User Experience Design (UED)":
        return "navajowhite";
    case "Web Applications":
        return "#B3EBF2";
    case "Web Design":
        return "lime";
    case "Web Framework":
        return "geekblue";
    default:
        return "grey";
  }
};
